export default [
  
    {
        path: '/events/orders/:type',
        name: 'orders',
        component: () => import('@/views/Orders.vue'),
        meta: {
            pageTitle: 'Olaylar',
            pageIcon: 'FigmaIcon',
            requiresAuth : true,
            breadcrumb: [
            {
                text: 'Sipariş Datası',
                active: true,
            },
            ],
        },
    },
    {
        path: '/events/click/:type',
        name: 'click',
        
        component: () => import('@/views/Events.vue'),
        meta: {
            pageTitle: 'Olaylar',
            pageIcon: 'MousePointerIcon',
            requiresAuth : true,
            breadcrumb: [
            {
                text: 'Tıklamalar',
                active: true,
            },
            ],
        },
    },
    {
        path: '/events/carts/:type',
        name: 'carts',
        component: () => import('@/views/Carts.vue'),
        meta: {
            pageTitle: 'Olaylar',
            pageIcon: 'ShoppingCartIcon',
            requiresAuth : true,
            breadcrumb: [
            {
                text: 'Cart Datası',
                active: true,
            },
            ],
        },
    },
]